import i18n from '@/i18n';

import { getAppFormatLocale } from './locale';

export const formatPrice = (price: number | string, currency?: string) => {
  return `${Number(price).toLocaleString(getAppFormatLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}${currency ? ` ${currency}` : ''}`;
};

export const formatPriceWithCurrency = formatPrice;

export default formatPrice;
